export function getModelUrl(obj) {
    return this.$localizedRoute(obj.modelClass + '.show', obj.id)
}

export function localizedRoute(name, params) {
    if (!name) {
        return null
    }

    const locale = this.$lang.getLocale()
    const fallback = this.$lang.getFallback()
    const localeRouteName = `${locale}.${name}`
    const fallbackRouteName = `${fallback}.${name}`

    // Check if the route exists with the current locale as prefix
    if (!!Ziggy.routes[localeRouteName]) {
        return route(localeRouteName, params)
        // Check if the route exists with the fallback locale as prefix
    } else if (!!Ziggy.routes[fallbackRouteName]) {
        return route(fallbackRouteName, params)
        // If the route does not exist with the current or fallback locale, return the route without the locale prefix
    } else {
        return route(name, params)
    }
}

export function isCurrentLocalizedRoute(name, params) {
    if (!name) {
        return false
    }
    const locale = this.$lang.getLocale()
    const fallback = this.$lang.getFallback()
    const localeRouteName = `${locale}.${name}`
    const fallbackRouteName = `${fallback}.${name}`

    if (!!Ziggy.routes[localeRouteName]) {
        return route().current(localeRouteName, params)
    } else if (!!Ziggy.routes[fallbackRouteName]) {
        return route().current(fallbackRouteName, params)
    } else {
        return route().current(name, params)
    }
}
